'use strict';

var DowGroupsDirective = function DowGroupsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/dow-groups.html'),
    requires: '^rmNewCalendar',
    controller: 'DowGroupController',
    scope: false
  };
};
DowGroupsDirective.$inject = [];
module.exports = DowGroupsDirective;